import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { blue } from '@material-ui/core/colors';
import ChatBubbleIcon from '@material-ui/icons/ChatBubble';
import Button from '@material-ui/core/Button';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';

import { Divider } from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 345,
  },
  avatar: {
    backgroundColor: blue[500],
  },
}));

const CardFaleConosco = props => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const { className, ...rest } = props;

  console.log('message speak with us:' + rest.faleconosco);


{/*Kadmiel - função para carregar os campos novos*/}


const handleWhatsAppClick = () => {
  const phoneNumber =
    rest.msgwhatsfone ||
    rest.MSGWHATSFONE ||
    "";

  const whatsappMessage =
    rest.msgwhatsperso ||
    rest.MSGWHATSPERSO ||
    "Olá, gostaria de conversar sobre o meu destino!";

  console.log("props recebidas:", rest);
  console.log("Telefone WhatsApp:", phoneNumber);
  console.log("Mensagem WhatsApp:", whatsappMessage);

  if (!phoneNumber) {
    alert("Telefone WhatsApp não configurado.");
    return;
  }

  let cleanPhone = String(phoneNumber).replace(/\D/g, "");

  if (!cleanPhone.startsWith("55")) {
    cleanPhone = `55${cleanPhone}`;
  }

  const text = encodeURIComponent(whatsappMessage);
  const url = `https://wa.me/${cleanPhone}?text=${text}`;

  window.open(url, "_blank", "noopener,noreferrer");
};

  return (
    <div>
      <Card className={classes.root}>
        <CardHeader
          avatar={
            <Avatar aria-label="recipe" className={classes.avatar}>
              <ChatBubbleIcon />
            </Avatar>
          }
          title="FALE CONOSCO"
        />

        <Divider />

        <CardContent>
          <Typography variant="body1" component="div">
            <div style={{ whiteSpace: 'pre-line' }}>
              {rest.faleconosco}
            </div>
          </Typography>
        </CardContent>

        <CardActions disableSpacing>
          <IconButton aria-label="add to favorites" />
          <IconButton aria-label="share" />
        </CardActions>

        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <CardContent>
            <Typography paragraph>
              Conteúdo expandido opcional.
            </Typography>
          </CardContent>
        </Collapse>
      </Card>

{/*Kadmiel - Criado botão novo do WhatsApp*/}
      <div
        style={{
          marginTop: 16,
          maxWidth: 345,
          width: "100%",
        }}
      >
        <Button
          variant="contained"
          startIcon={<WhatsAppIcon />}
          onClick={handleWhatsAppClick}
          fullWidth
          style={{
            backgroundColor: "#25D366",
            color: "#fff",
            height: 48,
            fontWeight: "bold"
          }}
        >
          Conversar no WhatsApp
        </Button>
      </div>
    </div>
  );
};
{/*Kadmiel - Novo prop para carregar os novos campos*/}
CardFaleConosco.propTypes = {
  faleconosco: PropTypes.string,
  msgwhatsfone: PropTypes.string,
  msgwhatsperso: PropTypes.string,
};

export default CardFaleConosco;